import Button, { ButtonProps } from '@carvana/ds-button';
import { Share } from 'lucide-react';
import { useSectionAnalytics } from '~/context/vdp/SectionAnalyticsContext';
import useShareLink from '~/hooks/vdp/useShareLink';
import { ActionsContainer } from './Actions.styles';
import Favorite from './Favorite';

export enum ActionsLocations {
  BreadCrumb = 'BreadCrumb',
  StickyBanner = 'StickyBanner',
  VehicleInfoCard = 'VehicleInfoCard'
}

type OwnProps = {
  className?: string;
  location: ActionsLocations;
  size: ButtonProps['size'];
};

export default function Actions({ className, location, size }: OwnProps) {
  const { analyticsAttributes, analyticsId } = useSectionAnalytics();
  const shareLink = useShareLink();

  return (
    <ActionsContainer className={className}>
      <Button
        data-adobe-id="share"
        data-analytics-id={analyticsId}
        data-analytics-attributes={JSON.stringify({
          ...analyticsAttributes,
          description: 'share'
        })}
        data-testid={`${location}-share`}
        icon
        onClick={shareLink}
        size={size}
        title="Share"
        variant="tertiary"
      >
        <Share />
        <span className="sr-only">Share</span>
      </Button>
      <Favorite data-testid={`${location}-favorite`} size={size} />
    </ActionsContainer>
  );
}
